import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import { IRet } from "../types/FmsTypes";
import { CLIENT_APP_CODE, getBaseRequestUrl, DEFAULT_REQUEST_TIMEOUT } from "./constants";
import { getToken, INTERNAL_SERVER_ERROR_CODE } from "./constants";
import { globalPrompt } from "../components/YhMessage";
import { message } from "antd";

class HttpRequest {

    private inst: AxiosInstance;

    constructor(config: AxiosRequestConfig = {}) {
        let defaultConfig = {
            baseURL: getBaseRequestUrl(),
            timeout: DEFAULT_REQUEST_TIMEOUT,
            headers: { 'CAC': CLIENT_APP_CODE }
        }
        this.inst = axios.create({ ...defaultConfig, ...config })
        this.interceptRequest();
        this.interceptResponse();
    }

    private interceptRequest() {
        this.inst.interceptors.request.use(
            config => {

                config.headers.Authorization = getToken();
                return config;
            },
            error => Promise.reject(error)
        )
    }

    private interceptResponse() {
        this.inst.interceptors.response.use(
            response => {
                // console.log(response, "响应拦截器")
                return response;

            },
            error => {
                let res = error.response as AxiosResponse;
                if (res && res.status) {
                    //处理自定义业务异常
                    switch (res.status) {
                        case 401:
                            globalPrompt("modal",
                                {
                                    title: "token失效",
                                    text: '为确保系统正常使用，请重新登陆',
                                    type: "warning",
                                    cancelShow: true,
                                    onOk: () => { console.log('确认离开') },
                                    onCancel: () => { }
                                })
                            console.log('认证错误');
                            break;
                        case 403:
                            globalPrompt("message", { type: "error", text: "没有权限访问资源" });
                            console.log('没有权限访问资源');
                            break;
                        case 404:
                            globalPrompt("message", { type: "error", text: "请求的资源不存在" });
                            console.log('请求的资源不存在');
                            break;
                        case 500:
                            globalPrompt("message", { type: "error", text: res.data && res.data.retMsg ? res.data.retMsg : '请求的资源不存在!' });
                            console.log('请求的资源不存在');
                            break;
                        default:
                            globalPrompt("message", { type: "error", text: res.data.retMsg ?? "连接错误" });
                            console.log('连接错误');
                    }
                } else {
                    message.error("请求超时");
                }
                return Promise.reject(error);
            }
        )
    }

    private responseTypeCheck(res: AxiosResponse) {
        const resData = res.data;
        switch (resData.retCode) {
            case 200:
                break;
            case "200":
                break;
            case 500:
                globalPrompt("message", { type: "error", text: resData.retMsg });
                break;
            case "500":
                globalPrompt("message", { type: "error", text: resData.retMsg });
                break;
            default:
                globalPrompt("message", { type: "error", text: "未配置的状态码！" });
        }
        const resType = res.headers["content-type"];
        if (resType !== "application/json") {
            console.log("只支持json返回数据!");
            //.....
        }
    }

    async request<T>(config: AxiosRequestConfig) {
        let ret = await this.inst.request<IRet<T>>(config);
        this.responseTypeCheck(ret);
        return ret.data;
    }

    async post<T>(url: string, data?: any, config?: AxiosRequestConfig) {
        let ret = await this.inst.post<IRet<T>>(url, data, config);
        this.responseTypeCheck(ret);
        return ret.data;
    }

    async get<T>(url: string, config?: AxiosRequestConfig) {
        let ret = await this.inst.get<IRet<T>>(url, config);
        this.responseTypeCheck(ret);
        return ret.data;
    }

    async put<T>(url: string, data?: any, config?: AxiosRequestConfig) {
        let ret = await this.inst.put<IRet<T>>(url, data, config);
        return ret.data;
    }

    async delete<T>(url: string, config?: AxiosRequestConfig) {
        let ret = await this.inst.delete<IRet<T>>(url, config);
        return ret.data;
    }

    async head<T>(url: string, config?: AxiosRequestConfig) {
        let ret = await this.inst.head<IRet<T>>(url, config);
        return ret.data;
    }

    async options<T>(url: string, config?: AxiosRequestConfig) {
        let ret = await this.inst.options<IRet<T>>(url, config);
        return ret.data;
    }

    async patch<T>(url: string, data?: any, config?: AxiosRequestConfig) {
        let ret = await this.inst.patch<IRet<T>>(url, data, config);
        return ret.data;
    }
}

export const httpRequest = new HttpRequest();
